import getAuthAxios from '../../utill/getAuthAxios';

const authAxios = getAuthAxios();

export const countRecipients = async filter => {
  const response = await authAxios.post('/mail/count', filter);
  return response.response.data?.data;
};

export const sendTestEmail = async data => {
  const response = await authAxios.post('/mail/test', data);
  return response.response.data?.data ?? {};
};

export const sendEmail = async data => {
  const response = await authAxios.post('/mail/send', data);
  return response.response.data?.data;
};

export const getRequestSummary = async requestId => {
  const response = await authAxios.get(`/mail/request/${requestId}/summary`);
  return response.response.data?.data;
};
